export enum Client {
  TPN = 'tpn',
  PNGS = 'pngs',
  Messe = 'messe',
  Bgpn = 'bgpn',
  Amplus = 'amplus',
  Meander = 'meander',
  Hawran = 'hawran',
  StartVelo = 'startVelo',
  DlugaPolana = 'dlugapolana',
  None = 'none',
}
